import { gql } from '@apollo/client'

import { ModalLock } from '../modal-lock'
import {
  LawsuitNameMonitoringLock_OfferLockDataFragment,
  LawsuitNameMonitoringLock_ViewerFragment,
} from './__generated__/lawsuit-name-monitoring-lock.graphql'
import { LawsuitNameMonitoringLockContent } from './lawsuit-name-monitoring-lock-content/lawsuit-name-monitoring-lock-content'

export interface LawsuitNameMonitoringLockProps {
  offerLockData: LawsuitNameMonitoringLock_OfferLockDataFragment
  viewer: LawsuitNameMonitoringLock_ViewerFragment
}

export function LawsuitNameMonitoringLock({
  offerLockData,
  viewer,
}: LawsuitNameMonitoringLockProps) {
  const { body } = offerLockData || {}
  const mappedBody = {
    ...body,
    cards: body?.cards.map((card) => ({
      ...card,
      creditCard: card.creditCard || null,
      lockEventProperties: card.lockEventProperties || {},
    })),
  }
  return (
    <ModalLock offerLockBody={mappedBody} size="sm">
      <LawsuitNameMonitoringLockContent offerLockData={offerLockData} viewer={viewer} />
    </ModalLock>
  )
}

LawsuitNameMonitoringLock.fragments = {
  offerLockData: gql`
    fragment LawsuitNameMonitoringLock_offerLockData on OfferLockData {
      ...LawsuitNameMonitoringLockContent_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${LawsuitNameMonitoringLockContent.fragments.offerLockData}
    ${ModalLock.fragments.offerLockBody}
  `,
  viewer: gql`
    fragment LawsuitNameMonitoringLock_viewer on Profile {
      ...LawsuitNameMonitoringLockContent_viewer
    }
    ${LawsuitNameMonitoringLockContent.fragments.viewer}
  `,
}
